let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1HNA9")).then(() => parcelRequire('akYEc'));